import Vue from 'vue';

const comboRepository = {
    get: (id) => Vue.$axios.get(`combos/${id}`)
        .then(({data}) => data, (error) => console.log(error)),

    list: () => Vue.$axios.get('combos')
        .then(({data}) => data, (error) => console.log(error)),

    upOrder: (comboId) => Vue.$axios.post('combos/up-order', {comboId})
        .then(({data}) => data, (error) => console.log(error)),

    downOrder: (comboId) => Vue.$axios.post('combos/down-order', {comboId})
        .then(({data}) => data, (error) => console.log(error)),

    edit: (comboId, description, image) => {
        let data = new FormData();
        data.append('comboId', comboId);

        if (description)
            data.append('description', description);

        if (image)
            data.append('image', image);

        return Vue.$axios.post('combos/edit', data)
            .then((data) => data, (error) => console.log(error))
    },
};

export default comboRepository;
